<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content [innerHTML]="data.message"></mat-dialog-content>
<mat-dialog-actions class="d-flex gap-3">
	@if (data.showCancelBtn) {
		<button
			class="btn btn-primary-ks-white"
			mat-dialog-close
		>
			{{ data.btnCancel }}
		</button>
	}
	<button
		#initialFocus
		class="btn btn-primary-ks"
		[mat-dialog-close]="true"
	>
		{{ data.btnConfirm }}
	</button>
</mat-dialog-actions>
